export default __webpack_public_path__ + "static/media/trash.eaee0935.svg";